module.exports = __webpack_public_path__ + "b413e8f0d2fffe8718e28b951dc72ccf.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-84@2x.png
// module id = 540
// module chunks = 0